import React from "react"; 
import '../styles/background.css'



function Background() {
    return (
        <div className='background-image'>          
        </div>
    )
}

export default Background;